import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import MaskedInput from 'react-text-mask';

//material-ui core
import {Drawer, Box, Divider} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Slide from '@material-ui/core/Slide';

//material-ui Icons
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';

//import others
import DrawersBrowser from '../Drawers/DrawersBrowser';
import FacebookProgress from './FacebookProgress';
import SearchBrowserDetails from './SearchBrowserDetails';

const useStyles = makeStyles((theme) => ({
  //search
  root_search: {
    padding: '2px 4px',
    top: 10,
    left: 10,
    display: 'flex',
    alignItems: 'center',
    width: 400,
    position: 'relative',
    borderRadius: 9,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  drawer: {
    flexDirection: 'unset',
  },

  //details
  details: {
    width: 400,
    marginLeft: 10,
    display: 'flex',
    background: 'white',
    padding: '13px 0px 10px 0px',
    borderRadius: '0px 0px 10px 10px',
    fontSize: 15,
  },
  detailsNone: {
    display: 'none',
  },
  detailsContent: {
    paddingTop: 5,
    display: 'flex',
    color: '#7e8a96',
    width: '100%',
    textDecoration: 'none',
    '&:hover': {
      color: 'black',
    },
  },
  detailsIcon: {
    width: 56,
    textAlign: 'center',
  },
  detailsExpand: {
    backgroundColor: '#fafafa',
    height: '100vh',
    width: 430,
    boxShadow: '0px -3px 20px 2px rgba(0,0,0,0.12)',
    position: 'absolute',
    top: 0,
    zIndex: -1,
  },
}));

const TextMaskCustom = (props) => {
  const {inputRef, ...other} = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      // kd_prov.kd_kabupaten.kd_kec.kd_kel.kd_blok.no_urut.kd_jns
      mask={[
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
      ]}
      placeholderChar={'_'}
    />
  );
};

const SearchBrowser = (props) => {
  const classes = useStyles();
  const {
    setDrawer,
    inputNop,
    setInputNop,
    facebookProgress,
    clearIcon,
    handleKeyPress,
    onClear,
    onSearchNop,
    checked,
    handleDetails,
    searchNop,
    searchSppt,
    piutangLoading,
    tahunSPPT,
    handleTahunSPPT,
    itemTahunSPPT,
    detailNop,
    detailSppt,
    images,
    streetView,
  } = props;

  return (
    <div>
      {/* search */}
      <div>
        <Paper component="div" className={classes.root_search}>
          <Tooltip title="Menu" arrow>
            <IconButton className={classes.iconButton} aria-label="menu" onClick={() => setDrawer(true)}>
              <MenuIcon />
            </IconButton>
          </Tooltip>

          <InputBase
            value={inputNop}
            onChange={(e) => setInputNop(e.target.value)}
            className={classes.input}
            placeholder="Search NOP"
            inputComponent={TextMaskCustom}
            onKeyDown={handleKeyPress}
          />

          {/* Loading Facebook */}
          {facebookProgress ? <FacebookProgress /> : null}

          {/* Clear Icon After Loading */}
          {clearIcon ? (
            <Tooltip title="Clear" arrow>
              <IconButton type="button" className={classes.iconButton} onClick={onClear} aria-label="close">
                <ClearRoundedIcon />
              </IconButton>
            </Tooltip>
          ) : null}

          <Divider className={classes.divider} orientation="vertical" />
          <Tooltip title="Search" arrow>
            <IconButton
              type="button"
              className={classes.iconButton}
              onClick={() => onSearchNop(inputNop)}
              // onClick={onSearchNop}
              aria-label="search">
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Paper>

        <Box className={!checked ? classes.details : classes.detailsNone} boxShadow={3} onClick={handleDetails}>
          <div className={classes.detailsContent}>
            <div className={classes.detailsIcon}>
              <ExpandMoreRoundedIcon />
            </div>
            Show More
          </div>
        </Box>
      </div>

      {/*    Expand   */}
      <Slide in={checked}>
        <div className={classes.detailsExpand}>
          <SearchBrowserDetails
            checked={checked}
            handleDetails={handleDetails}
            searchNop={searchNop}
            searchSppt={searchSppt}
            piutangLoading={piutangLoading}
            tahunSPPT={tahunSPPT}
            handleTahunSPPT={handleTahunSPPT}
            itemTahunSPPT={itemTahunSPPT}
            detailNop={detailNop}
            detailSppt={detailSppt}
            images={images}
            streetView={streetView}
          />
        </div>
      </Slide>
    </div>
  );
};

export default SearchBrowser;
